<template>
    <b-modal title="Add Case Note"
        header-bg-variant="success"
        header-text-variant="light"
        size="lg"
        :visible="true"
        centered
        @hide="modalClose"
        @ok="addNote"
    >
        <b-form-group label-class='addpersonlabel' label='Date' label-for="date" :horizontal='false'>
          <datepicker
            name="date"
            input-class="form-control-lg"
            initial-view="day"
            v-model="note.customDate"
            placeholder="Select Date"
            :format="this.$dateFormatter"
            :disabled-dates="{ from: new Date() }"
            clear-button
          />
        </b-form-group>
        <b-form-group label="Title" label-class='addpersonlabel' label-for="title">
            <b-form-input size="lg" type='text' name="title" v-model="note.title"></b-form-input>
        </b-form-group>

        <b-form-group
          label="Type"
          style="width: 300px"
        >
          <v-select
            :options="noteTypes"
            label="title"
            v-model="note.noteType"
            :reduce="noteType => noteType.value"
            placeholder="Type to Search"
          >
          </v-select>
        </b-form-group>

        <b-form-textarea rows="10" class="mt-3" placeholder="Enter Note" name="note" v-model="note.note"></b-form-textarea>
        <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="addNote"
          >
            Submit
          </b-button>
          <b-button
            variant="link"
            size="sm"
            class="float-right"
            @click="modalClose"
          >
            Cancel
          </b-button>
        </div>
      </template>
    </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'add-note-modal',
  props: {
    personId: Number
  },
  computed: {
    ...mapGetters({
      note: 'getCreateNote',
      noteTypes: 'getNoteTypes'
    })
  },
  methods: {
    addNote: function () {
      this.note.customDate = new Date(this.note.customDate).getTime()
      this.$store.dispatch('createNote', this.note)
      this.$emit('modalClose')
    },
    modalClose: function () {
      this.$emit('modalClose')
    }
  },
  created () {
    this.note.person = this.personId
    this.note.customDate = new Date()
  },
  mounted () {
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/t1/AddNoteModal.vue